module.exports = __webpack_public_path__ + "img/xiecheng.39840b9d.jpeg";